import React from 'react'
import Router from './router'

function App() {
  return (
    <div className='container'>
      <Router />
    </div>
  )
}

export default App
